var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactOsProductLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ReactOSProductLogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.455,
    gradientTransform: "translate(-0.049 -0.049) scale(1.099 1.099)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.674,
    cy: 0.13,
    r: 0.555,
    gradientTransform: "matrix(-1.165, 0.537, 0.661, 0.752, -0.801, 0.634)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3.317,
    y1: 0.555,
    x2: 2.133,
    y2: 1.686,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 0.5,
    r: 0.451,
    gradientTransform: "translate(-0.054 -0.054) scale(1.108 1.108)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.416
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.5,
    cy: 0.5,
    r: 0.552,
    gradientTransform: "translate(0.047 0.047) scale(0.906 0.906)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.412,
    cy: 0.671,
    r: 0.959,
    gradientTransform: "matrix(0.646, -0.433, 0.192, 0.557, 0.193, 0.819)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "translate(0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#466886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#617689",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 2.415,
    cy: 1.232,
    r: 1.665,
    gradientTransform: "matrix(1.422, 0.011, -0.015, 1.002, -0.999, -0.028)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 0.505,
    cy: -1.37,
    r: 2.289,
    gradientTransform: "matrix(0.299, 0.011, -0.003, 1.002, 0.35, -0.003)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 0.5,
    cy: 0.5,
    r: 0.41,
    gradientTransform: "translate(-0.11 -0.11) scale(1.22 1.22)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: -0.096,
    cy: 1.076,
    r: 0.762,
    gradientTransform: "matrix(0.856, 0.73, -1.567, 1.169, 2.037, -0.644)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: -1.478,
    cy: 1.201,
    r: 1.659,
    gradientTransform: "matrix(1.46, 0.011, -0.016, 1.002, 0.699, 0.014)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 2.443,
    cy: 0.189,
    r: 1.12,
    gradientTransform: "matrix(2.11, 0.011, -0.023, 1.002, -2.707, -0.026)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 0.5,
    cy: 0.5,
    r: 0.451,
    gradientTransform: "translate(-0.054 -0.054) scale(1.108 1.108)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: -149.952,
    cy: 149.789,
    r: 353.87,
    gradientTransform: "translate(-1.037 1.575) scale(1.044 0.999)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: -1.369,
    cy: 0.165,
    r: 1.128,
    gradientTransform: "matrix(2.032, 0.011, -0.022, 1.002, 1.416, 0.014)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 0.5,
    cy: 0.5,
    r: 0.525,
    gradientTransform: "translate(0.024 0.024) scale(0.952 0.952)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#e5f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254863",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 0.5,
    cy: 0.5,
    r: 0.52,
    gradientTransform: "matrix(0.946, -0.119, 0.141, 1.23, -0.048, -0.062)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5f4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cy: 0.5,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: 0.5,
    cy: 0.5,
    r: 0.495,
    gradientTransform: "translate(-0.004 -0.003) scale(1.009 1.009)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: 0.5,
    cy: 0.5,
    r: 0.552,
    gradientTransform: "translate(0.047 0.047) scale(0.906 0.906)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: 0.241,
    cy: 0.548,
    r: 0.5,
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 0.495,
    cy: 2.37,
    r: 2.289,
    gradientTransform: "matrix(0.299, 0.011, -0.003, 1.002, 0.354, -0.01)",
    xlinkHref: "#radial-gradient-12"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 74,
    height: 75,
    rx: 6,
    fill: "#6294b9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ReactOS_logo",
    transform: "translate(-125.752 -9.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M200.4,403.905A21.593,21.593,0,1,1,178.8,382.273,21.613,21.613,0,0,1,200.4,403.905Z",
    transform: "translate(-18.582 -352.055)",
    fillRule: "evenodd",
    opacity: 0.3,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M200.4,403.905A21.593,21.593,0,1,1,178.8,382.273,21.613,21.613,0,0,1,200.4,403.905Z",
    transform: "translate(-15.66 -355.074)",
    fill: "#244762",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M178.507,157.779a21.588,21.588,0,0,0,.24,8.554q.181.783.418,1.546s0,0,0,0c.053.168.108.335.164.5.111.328.229.651.356.973,0,.006.006.012.009.018l0,.013c.124.313.253.627.391.933l.013.027c.067.149.134.3.2.444.005.011.013.02.018.031.071.148.143.3.218.444.036.071.074.142.111.213.048.091.093.181.142.271.007.012.015.023.022.036q.1.192.213.382l.027.044c.083.144.167.289.253.431l.027.044c.265.436.545.864.84,1.28.089.126.18.25.271.373.011.015.024.029.036.044a21.491,21.491,0,0,0,13.625,8.377c1.015-4.958-2.82-8.118-5.644-10.821-.457-.8-1.994-1.42-2.635-2.289-2.106-3.264-5.263-6.257-9.323-11.878Z",
    transform: "translate(-36.643 -112.619)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M342.257,141.537a21.278,21.278,0,0,1-3.459,11.726,21.9,21.9,0,0,1-4.172,4.775c-4.013-.1-6.692-1.833-7.028-2.764,5.2-4.776,9.057-10.9,7.727-12.953a35.577,35.577,0,0,1,3.467-6.378l1.821-2.779A21.3,21.3,0,0,1,342.257,141.537Z",
    transform: "translate(-157.518 -92.705)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M361.956,129.707a1.885,1.885,0,0,1-1.854,2.708,4.272,4.272,0,0,1-3.728-2.733,1.885,1.885,0,0,1,1.854-2.708A4.272,4.272,0,0,1,361.956,129.707Z",
    transform: "translate(-180.674 -87.696)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M356.241,128.278a1.885,1.885,0,0,1-1.854,2.708,4.271,4.271,0,0,1-3.728-2.733,1.885,1.885,0,0,1,1.854-2.708A4.272,4.272,0,0,1,356.241,128.278Z",
    transform: "translate(-176.05 -86.54)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M365.528,125.421a1.885,1.885,0,0,1-1.854,2.708,4.272,4.272,0,0,1-3.728-2.733,1.885,1.885,0,0,1,1.854-2.708A4.272,4.272,0,0,1,365.528,125.421Z",
    transform: "translate(-183.564 -84.228)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M361.485,150.936a2.708,2.708,0,0,1-1.157,3.744,2.94,2.94,0,0,1-3.807-1.395,2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,361.485,150.936Z",
    transform: "translate(-180.65 -105.747)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M186.2,104.067a14.74,14.74,0,1,1-14.734-15.143A14.943,14.943,0,0,1,186.2,104.067Z",
    transform: "translate(-13.168 -53.337)",
    fill: "url(#radial-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M200.012,133.177c-6.667.085-13.661,1.712-17.311,5.169-5.377,3.255-4.227,10.193,1.589,17.338a21.609,21.609,0,0,0,32.222.51c5.4-5.427,6.667-12.61.333-17.764C212.919,135.154,206.6,133.023,200.012,133.177Z",
    transform: "translate(-37.489 -92.709)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M347.03,89.384a2.024,2.024,0,1,1-2.014-1.819,2.021,2.021,0,0,1,1.875,1.156",
    transform: "translate(-172.031 -27.508)",
    opacity: 0.54,
    fill: "url(#radial-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M628.868,150.358a3.706,3.706,0,1,1-3.649-3.061,3.7,3.7,0,0,1,3.4,1.945",
    transform: "translate(-450.883 -89.431)",
    opacity: 0.54,
    fill: "url(#radial-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M256.23,77.159a1.489,1.489,0,1,1-1.487-1.571,1.491,1.491,0,0,1,1.384,1",
    transform: "translate(-88.326 -10.717)",
    opacity: 0.441,
    fill: "url(#radial-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M163.795,79.066a26.117,26.117,0,0,0-7.265,13.156q-.137.637-.244,1.286l4.47.739q.088-.536.2-1.063a21.586,21.586,0,0,1,6.006-10.873",
    transform: "translate(-18.922 -48.937)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M186.2,104.067a14.74,14.74,0,1,1-14.734-15.143A14.943,14.943,0,0,1,186.2,104.067Z",
    transform: "translate(-11.53 -50.609)",
    fill: "url(#radial-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M230.474,259.8a26.081,26.081,0,0,1-36.942-.4l3.238-3.177a21.555,21.555,0,0,0,30.532.327",
    transform: "translate(-49.055 -192.266)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M150.856,79.691a11.942,11.942,0,1,1-11.937-11.6A11.771,11.771,0,0,1,150.856,79.691Z",
    transform: "translate(18.152 -24.937)",
    fill: "url(#radial-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M68.734,79.751c-.457-.012-.923-.009-1.414,0a7.862,7.862,0,0,0-5.976,2.286A8.207,8.207,0,0,0,59.406,88.1a22.176,22.176,0,0,0,2.16,8.093c2.641,5.872,7.559,12.529,14.167,18.707s13.445,10.543,19.375,12.718a21.883,21.883,0,0,0,8.1,1.549,8.693,8.693,0,0,0,5.945-2.245c1.915-1.867,2.456-4.809,1.894-8.222a32.445,32.445,0,0,0-4.274-10.837c-.453,1.145-.618,1.791-.8,2.33,2.063,3.926,2.891,5.574,3.442,8.548s.135,5.283-1.286,6.811a6.693,6.693,0,0,1-4.9,1.888,20.847,20.847,0,0,1-7.613-1.5c-5.727-2.113-12.48-6.393-18.823-12.323S65.7,101.223,63.168,95.649a21.226,21.226,0,0,1-2.076-7.485,6.584,6.584,0,0,1,1.471-4.976c1.36-1.464,3.509-1.941,6.412-1.759s4.146.553,8.114,2.393c.514-.5,1.3-.461,1.932-.657A37.432,37.432,0,0,0,68.734,79.751Z",
    transform: "translate(77.911 -55.123)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M343.146,162.812c2.641,1.663,2.989,5.156.778,7.8s-6.145,3.444-8.787,1.782-2.989-5.156-.778-7.8S340.5,161.149,343.146,162.812Z",
    transform: "translate(-161.811 -115.988)",
    fill: "url(#radial-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M345.58,151.415c2.71,1.548,3.207,5.023,1.111,7.762s-5.992,3.7-8.7,2.156-3.207-5.023-1.111-7.762S342.87,149.867,345.58,151.415Z",
    transform: "translate(-163.977 -106.873)",
    fill: "url(#radial-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M338.922,165.887c.594,3.064-1.715,5.708-5.159,5.906s-6.717-2.125-7.311-5.189,1.715-5.708,5.159-5.906S338.327,162.823,338.922,165.887Z",
    transform: "translate(-156.516 -114.971)",
    fill: "url(#radial-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M322.265,159.545c2.411,1.516,1.678,3.766-1.636,5.024s-7.955,1.049-10.366-.468-1.678-3.766,1.636-5.024S319.854,158.028,322.265,159.545Z",
    transform: "translate(-142.345 -113.004)",
    fill: "url(#radial-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M340.733,124.4a7.133,7.133,0,0,1-5.55,8.132,6.573,6.573,0,0,1-7.966-5.208,7.133,7.133,0,0,1,5.55-8.132A6.573,6.573,0,0,1,340.733,124.4Z",
    transform: "translate(-157.123 -81.269)",
    fill: "url(#radial-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M37.845,18.473c0,11.941-4.332,24.792-16.251,24.792A21.632,21.632,0,0,1,21.593,0C33.513,0,37.845,6.532,37.845,18.473Z",
    transform: "matrix(0.801, 0.599, -0.599, 0.801, 158.799, 18.577)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M351.484,141.649a2.708,2.708,0,0,1-1.157,3.744A2.94,2.94,0,0,1,346.52,144a2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,351.484,141.649Z",
    transform: "translate(-172.558 -98.233)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M201.1,104.7c1.368,1.032,1.381,3.307.03,5.081s-3.556,2.374-4.923,1.342-1.381-3.307-.03-5.081S199.728,103.666,201.1,104.7Z",
    transform: "translate(-50.378 -69.267)",
    fill: "#fff",
    opacity: 0.244
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M375.321,81.135A26.12,26.12,0,0,1,382.3,94.443q.124.64.216,1.291l-4.49.644q-.076-.538-.179-1.067a21.587,21.587,0,0,0-5.77-11",
    transform: "translate(-193.506 -50.611)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M104.545,80.158c-4.608-.037-7.708,1.46-11.721,3.236a5.385,5.385,0,0,1,1.492.717c3.791-1.537,5.859-2.242,8.831-2.507s5.424.192,6.679,1.756c2.078,2.591,1.9,6.956-.546,12.4s-7.115,11.9-13.718,18.5c-1.007,1.006-2.1,1.907-3.186,2.806a.5.5,0,0,0-.041.743c.076.078.145.145.2.21a.5.5,0,0,0,.7.063h0c1.079-.9,2.2-1.826,3.252-2.872,6.587-6.535,11.428-13.065,14.029-18.77s2.992-10.677.4-13.91C109.51,80.774,107.159,80.179,104.545,80.158ZM65.465,108.732c-2.145,3.988-3.58,7.123-4.138,10.346s-.084,6.054,1.715,7.983c1.968,2.111,5.059,2.761,8.758,2.189s8.058-2.355,12.765-5.2a.5.5,0,0,0,.009-.853,1.37,1.37,0,0,0-.229-.2.5.5,0,0,0-.555-.028,36.692,36.692,0,0,1-12.05,4.9c-3.439.569-6.087.024-7.692-1.7-1.449-1.554-1.91-3.812-1.43-6.688s1.542-4.951,3.242-8.948a3.05,3.05,0,0,1-.4-1.8Z",
    transform: "translate(76.529 -55.458)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M159.495,76.809a.059.059,0,0,0-.1,0l-.006.006a31.987,31.987,0,0,0-4.649,11.023c-.566,3.278-.083,6.044,1.665,7.919,1.921,2.06,5.195,2.626,9.2,1.945a40.828,40.828,0,0,0,13.607-5.544.058.058,0,0,0,.03-.042.066.066,0,0,0-.012-.054.055.055,0,0,0-.012-.012c-.1-.066-.15-.146-.269-.233a.063.063,0,0,0-.066,0,41.679,41.679,0,0,1-13.195,5.353c-3.909.706-7.1.232-8.9-1.707-1.629-1.747-2.125-4.275-1.611-7.358a31.434,31.434,0,0,1,4.434-10.652.063.063,0,0,0,.006-.048M198.858,47.68c-4.507.077-8.589,1.885-12.586,3.813.251.068.5.132.746.209a31.423,31.423,0,0,1,10.79-3.437c3.171-.283,5.9.186,7.358,2.005,2.329,2.9,2.072,7.641-.507,13.392s-7.475,12.506-14.382,19.407c-1.069,1.068-2.234,2.018-3.36,2.954l-.006.006a.063.063,0,0,0,0,.084c.08.081.161.167.233.251l.006.006a.063.063,0,0,0,.065.012.06.06,0,0,0,.018-.012c1.125-.939,2.275-1.89,3.354-2.96,6.832-6.779,11.846-13.552,14.52-19.419s3.013-10.844.471-14.012c-1.343-1.674-3.624-2.276-6.278-2.3C199.153,47.679,199,47.677,198.858,47.68Z",
    transform: "translate(-17.493 -23.544)",
    fill: "#5f5f5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M88.765,64.559c-6.234-.055-10.442,2.809-15.585,5.415a3.2,3.2,0,0,1,2.111.157c4.872-2.349,6.956-3.231,10.514-3.816,3.524-.579,6.5.126,7.808,1.54a6.853,6.853,0,0,1,1.543,5.092,21.243,21.243,0,0,1-2.029,7.563c-2.5,5.615-7.237,12.1-13.6,18.036q-1.786,1.665-3.6,3.151a.609.609,0,0,0-.041.906c.075.074.141.141.2.2a.613.613,0,0,0,.84.066q1.84-1.513,3.653-3.2C87.2,93.5,92.055,86.85,94.638,80.983A22.2,22.2,0,0,0,96.723,72.9a8.423,8.423,0,0,0-1.906-6.055A8.042,8.042,0,0,0,88.765,64.559ZM51.849,89.669a35.269,35.269,0,0,0-6.312,12.386c-1.036,3.89-.706,7.244,1.4,9.5,1.908,2.046,4.905,2.752,8.46,2.324a33.792,33.792,0,0,0,12.194-4.522.6.6,0,0,0-.016-1.063c-.125-.066-.236-.127-.336-.188a.607.607,0,0,0-.611-.019h0a33.17,33.17,0,0,1-11.345,4.177c-3.24.417-5.722-.173-7.212-1.772-1.642-1.761-1.946-4.536-.991-8.093s3.5-8.046,4.948-10.479A4.948,4.948,0,0,1,51.849,89.669Z",
    transform: "translate(89.585 -42.838)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M183.893,32.589c-6.325-.055-11.771,2.9-17.02,5.914a.069.069,0,0,0-.03.06c.323-.016.646-.028.973-.03A38.451,38.451,0,0,1,180.725,33.3c3.788-.622,7.064.069,8.635,1.772a7.705,7.705,0,0,1,1.754,5.705,22.623,22.623,0,0,1-2.16,8.086c-2.65,5.943-7.624,12.748-14.3,18.972q-1.873,1.746-3.778,3.306a.072.072,0,0,0-.03.054.079.079,0,0,0,.024.06c.081.08.167.158.239.239a.075.075,0,0,0,.1.012q1.9-1.566,3.778-3.318c6.852-6.39,11.864-13.265,14.514-19.282a22.637,22.637,0,0,0,2.13-8.212,8.213,8.213,0,0,0-1.844-5.92A7.831,7.831,0,0,0,183.893,32.589ZM146.4,58.716c.023-.348.056-.69.1-1.033-3.591,4.979-6.041,9.606-7.09,13.541s-.7,7.207,1.331,9.381c1.835,1.968,5.066,2.634,9.053,2.065a36.975,36.975,0,0,0,13.636-5.395.071.071,0,0,0,.036-.066.076.076,0,0,0-.042-.065c-.13-.07-.252-.109-.376-.185A38.461,38.461,0,0,1,149.7,82.181c-3.838.556-6.892-.09-8.606-1.928-1.887-2.023-2.18-5.147-1.158-8.952A41.768,41.768,0,0,1,146.4,58.716Z",
    transform: "translate(-4.802 -11.335)",
    fill: "#5f5f5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M159.293,155.428q-.088.536-.149,1.081a21.846,21.846,0,0,0-.135,2.21,21.582,21.582,0,0,0,6.165,15.361l-3.238,3.177a26.117,26.117,0,0,1-7.457-18.586,26.493,26.493,0,0,1,.164-2.673q.074-.659.18-1.308",
    transform: "translate(-17.459 -110.119)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M324.354,133.388a2.088,2.088,0,0,1-.848,2.84,2.125,2.125,0,0,1-2.792-1.058,2.088,2.088,0,0,1,.848-2.84A2.125,2.125,0,0,1,324.354,133.388Z",
    transform: "translate(-151.751 -91.873)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M325.051,133.076a2.708,2.708,0,0,1-1.157,3.744,2.94,2.94,0,0,1-3.807-1.395,2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,325.051,133.076Z",
    transform: "translate(-151.173 -91.298)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M326.48,133.791a2.708,2.708,0,0,1-1.157,3.744,2.94,2.94,0,0,1-3.807-1.395,2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,326.48,133.791Z",
    transform: "translate(-152.329 -91.876)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M331.481,135.22a2.708,2.708,0,0,1-1.157,3.744,2.94,2.94,0,0,1-3.807-1.395,2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,331.481,135.22Z",
    transform: "translate(-156.375 -93.032)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M332.2,135.22a2.708,2.708,0,0,1-1.157,3.744,2.94,2.94,0,0,1-3.807-1.395,2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,332.2,135.22Z",
    transform: "translate(-156.953 -93.032)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M332.91,135.934a2.708,2.708,0,0,1-1.157,3.744,2.94,2.94,0,0,1-3.807-1.395,2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,332.91,135.934Z",
    transform: "translate(-157.531 -93.61)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M340.768,135.934a2.708,2.708,0,0,1-1.157,3.744,2.94,2.94,0,0,1-3.807-1.395,2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,340.768,135.934Z",
    transform: "translate(-163.889 -93.61)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M340.768,135.934a2.708,2.708,0,0,1-1.157,3.744,2.94,2.94,0,0,1-3.807-1.395,2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,340.768,135.934Z",
    transform: "translate(-163.889 -93.61)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M345.769,130.933a2.708,2.708,0,0,1-1.157,3.744,2.94,2.94,0,0,1-3.807-1.395,2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,345.769,130.933Z",
    transform: "translate(-167.934 -89.564)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M328.623,146.65a2.708,2.708,0,0,1-1.157,3.744A2.94,2.94,0,0,1,323.659,149a2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,328.623,146.65Z",
    transform: "translate(-154.063 -102.279)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M340.768,151.651a2.708,2.708,0,0,1-1.157,3.744A2.94,2.94,0,0,1,335.8,154a2.708,2.708,0,0,1,1.157-3.744A2.94,2.94,0,0,1,340.768,151.651Z",
    transform: "translate(-163.889 -106.325)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M162.062,48.179c-.252,0-.5,0-.752.006-2.522.035-4.48.688-5.866,2.178a7.862,7.862,0,0,0-1.755,5.854,22.507,22.507,0,0,0,2.19,8.188c2.7,6.011,7.783,12.9,14.615,19.282S184.39,94.58,190.457,96.8a22.259,22.259,0,0,0,8.2,1.575,8.647,8.647,0,0,0,5.86-2.16c1.8-1.752,2.261-4.57,1.695-8A32.718,32.718,0,0,0,201.252,76.5a.036.036,0,0,0-.012-.012l-.006-.006c-.038.221-.075.438-.119.657a33.46,33.46,0,0,1,4.655,10.909c.6,3.213.159,5.863-1.5,7.645a7.633,7.633,0,0,1-5.556,2.172,22.263,22.263,0,0,1-8.17-1.6c-6.075-2.241-13.164-6.741-19.825-12.968S159.075,70.281,156.393,64.37a22.681,22.681,0,0,1-2.22-8.033,7.5,7.5,0,0,1,1.7-5.646c1.6-1.72,4.076-2.23,7.191-2.035a29.015,29.015,0,0,1,10.754,3.378c.2-.059.4-.108.6-.161-4.709-2.475-8.612-3.641-12.353-3.694Z",
    transform: "translate(-16.813 -23.948)",
    fill: "#5f5f5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M74.524,56.367a7.852,7.852,0,0,0-6.057,2.276,8.245,8.245,0,0,0-1.945,6.051,22.31,22.31,0,0,0,2.125,8.118c2.615,5.9,7.511,12.583,14.118,18.76s13.54,10.593,19.53,12.784a21.709,21.709,0,0,0,8.146,1.541,8.179,8.179,0,0,0,5.849-2.372c2.14-2.3,2.5-5.809,1.445-9.855a30.252,30.252,0,0,0-2.628-6.481q-.912-1.71-2.071-3.486-.578-.888-1.216-1.791a4.191,4.191,0,0,1-.3-.473,4.539,4.539,0,0,0-.382-.557.387.387,0,0,0-.68.337,2.424,2.424,0,0,1,.126.771c-.007.156-.052.335-.075.674a.388.388,0,0,0,.066.25c.344.493.68.989,1,1.493q.968,1.514,1.806,3.1a42.3,42.3,0,0,1,2.806,6.586l.006.018c.979,3.638.658,6.485-1,8.266a6.655,6.655,0,0,1-4.883,1.89,20.546,20.546,0,0,1-7.547-1.511c-5.681-2.119-12.393-6.4-18.745-12.33-6.553-6.117-11.362-12.639-13.886-18.23A20.615,20.615,0,0,1,68.11,64.7a6.682,6.682,0,0,1,1.571-5.015c1.466-1.553,4.166-2.058,7.7-1.439,3.558.623,5.14,1.259,9.853,3.627a5.346,5.346,0,0,1,2.734.014C83.7,57.94,79.079,56.346,74.524,56.367Z",
    transform: "translate(73.76 -34.73)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M337.235,127.346c.35.6-.211,1.081-1.253,1.079a3.178,3.178,0,0,1-2.519-1.089c-.35-.6.211-1.081,1.253-1.078A3.178,3.178,0,0,1,337.235,127.346Z",
    transform: "translate(-162.179 -87.117)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M176.425,32.373c-2.572.012-4.557.668-5.962,2.178a7.957,7.957,0,0,0-1.856,5.866,23.032,23.032,0,0,0,2.256,8.23c2.679,6.041,7.736,12.96,14.567,19.348s14,10.944,20.135,13.189a22.08,22.08,0,0,0,8.253,1.57,8.364,8.364,0,0,0,5.86-2.28c2.043-2.2,2.243-5.591,1.17-9.692s-3.616-8.908-7.448-13.929l-.006-.006c.046.313.081.631.113.949a41.638,41.638,0,0,1,6.9,13.105c1.056,3.909.746,7.142-1.176,9.208a7.557,7.557,0,0,1-5.514,2.16,21.933,21.933,0,0,1-8.092-1.611c-6.022-2.246-13.159-6.752-19.825-12.974-6.876-6.418-11.832-13.255-14.508-19.181a22,22,0,0,1-2.16-8.033,7.585,7.585,0,0,1,1.8-5.663c1.734-1.837,4.781-2.345,8.57-1.683a39.124,39.124,0,0,1,12.831,5.24c.312,0,.622.012.931.03-6.422-4.027-12.249-6.043-16.841-6.021Z",
    transform: "translate(-28.884 -11.161)",
    fill: "#5f5f5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M332.948,123.774c.35.6-.211,1.081-1.253,1.078a3.178,3.178,0,0,1-2.519-1.089c-.35-.6.211-1.081,1.253-1.078A3.178,3.178,0,0,1,332.948,123.774Z",
    transform: "translate(-158.711 -84.227)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M340.807,132.347c.35.6-.211,1.081-1.253,1.078a3.178,3.178,0,0,1-2.519-1.089c-.35-.6.211-1.081,1.253-1.078A3.178,3.178,0,0,1,340.807,132.347Z",
    transform: "translate(-165.069 -91.162)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(167.905 36.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M337.934,119.452c.35.6-.211,1.081-1.253,1.078a3.178,3.178,0,0,1-2.519-1.089c-.35-.6.211-1.081,1.253-1.078A3.178,3.178,0,0,1,337.934,119.452Z",
    transform: "translate(-331.261 -116.999)",
    opacity: 0.5,
    fill: "url(#radial-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M336.148,122.309c.35.6-.211,1.081-1.253,1.078a3.178,3.178,0,0,1-2.519-1.089c-.35-.6.211-1.081,1.253-1.078A3.178,3.178,0,0,1,336.148,122.309Z",
    transform: "translate(-329.816 -119.311)",
    opacity: 0.5,
    fill: "url(#radial-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M328.289,118.023c.35.6-.211,1.081-1.253,1.078a3.177,3.177,0,0,1-2.519-1.089c-.35-.6.211-1.081,1.253-1.078A3.177,3.177,0,0,1,328.289,118.023Z",
    transform: "translate(-323.459 -115.843)",
    opacity: 0.5,
    fill: "url(#radial-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M323.289,112.308c.35.6-.211,1.081-1.253,1.078a3.177,3.177,0,0,1-2.519-1.089c-.35-.6.211-1.081,1.253-1.078A3.178,3.178,0,0,1,323.289,112.308Z",
    transform: "translate(-319.413 -111.219)",
    opacity: 0.5,
    fill: "url(#radial-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M330.433,115.88c.35.6-.211,1.081-1.253,1.078a3.178,3.178,0,0,1-2.519-1.089c-.35-.6.211-1.081,1.253-1.078A3.178,3.178,0,0,1,330.433,115.88Z",
    transform: "translate(-325.193 -114.109)",
    opacity: 0.5,
    fill: "url(#radial-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M342.577,128.025c.35.6-.211,1.081-1.253,1.078a3.177,3.177,0,0,1-2.519-1.089c-.35-.6.211-1.081,1.253-1.078A3.177,3.177,0,0,1,342.577,128.025Z",
    transform: "translate(-335.018 -123.934)",
    opacity: 0.5,
    fill: "url(#radial-gradient-39)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M339.2,127.687l-.061-.064Z",
    transform: "translate(-166.858 -88.222)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M381.119,157.592l-4.291.609c-.056.089-.11.179-.167.269.036.281.07.563.1.847a21.962,21.962,0,0,1,.089,2.214,21.585,21.585,0,0,1-6.493,15.224L373.528,180a26.117,26.117,0,0,0,7.854-18.423,26.533,26.533,0,0,0-.107-2.679C381.234,158.459,381.18,158.026,381.119,157.592Z",
    transform: "translate(-192.109 -112.467)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M225.379,71.828c1.447,2.771-.188,6.452-3.652,8.222s-7.445.958-8.892-1.813.188-6.452,3.652-8.222S223.932,69.057,225.379,71.828Z",
    transform: "translate(-64.246 -40.857)",
    fill: "url(#radial-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M226.347,74.272c1.007,1.933-.131,4.5-2.542,5.735s-5.183.668-6.191-1.265.131-4.5,2.542-5.735S225.34,72.339,226.347,74.272Z",
    transform: "translate(-68.242 -43.507)",
    fill: "url(#radial-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M227.339,70.486c1.779.832,1.976,3.33.44,5.577s-4.225,3.4-6,2.563-1.976-3.33-.44-5.577S225.559,69.653,227.339,70.486Z",
    transform: "translate(-70.711 -41.776)",
    fill: "url(#radial-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M426.679,112.089a2.484,2.484,0,1,1-2.476-2.282,2.481,2.481,0,0,1,2.305,1.45",
    transform: "translate(-262.825 -79.319)",
    opacity: 0.2,
    fill: "url(#radial-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M2.427,1.942c0,1.072-.543,1.942-1.214,1.942S0,3.014,0,1.942.543,0,1.214,0c.5,0,.948.49,1.13,1.234",
    transform: "translate(144.923 56.832) rotate(-33.816)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M261.2,258.647c.518.669.547,1.438.063,1.718s-1.3-.035-1.815-.7-.547-1.438-.063-1.718a1.333,1.333,0,0,1,1.412.3",
    transform: "translate(-102.05 -193.572)",
    fill: "#d9dfe4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M277.729,273.3a1.038,1.038,0,0,1-.033-1.453,1.053,1.053,0,0,1,1.427.315,1.038,1.038,0,0,1,.033,1.453.94.94,0,0,1-1.113-.032",
    transform: "translate(-116.92 -204.765)",
    fill: "#a3b1be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M303.631,231.3c.381.447.4.96.046,1.147a1.228,1.228,0,0,1-1.334-.47c-.381-.447-.4-.96-.046-1.147a1.055,1.055,0,0,1,1.038.2",
    transform: "translate(-136.843 -171.666)",
    fill: "#e1e6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M320.578,246.353c.372.362.392.779.045.931a1.344,1.344,0,0,1-1.3-.381c-.372-.362-.392-.779-.045-.931a1.2,1.2,0,0,1,1.014.161",
    transform: "translate(-150.585 -183.925)",
    fill: "#a2b1be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M294.56,69.144c-1.658.054-2.94.771-3.062,1.831-.1.908.674,1.83,1.9,2.417a6.251,6.251,0,0,0-1.235,4.835,6.89,6.89,0,1,0,6.679-7.581,5.489,5.489,0,0,0-3.08-1.431A6.615,6.615,0,0,0,294.56,69.144Z",
    transform: "translate(-128.348 -40.764)",
    opacity: 0.361,
    fill: "url(#radial-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M331.119,100c-1.4,2.266-4.962,2.235-7.952-.069s-4.278-6.01-2.876-8.276,4.962-2.235,7.952.069S332.521,97.735,331.119,100Z",
    transform: "translate(-151.148 -57.764)",
    fill: "url(#radial-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M335.342,101.961c.047.9-.719,1.338-1.712.97a2.949,2.949,0,0,1-1.883-2.3c-.047-.9.719-1.338,1.712-.97A2.949,2.949,0,0,1,335.342,101.961Z",
    transform: "translate(-160.874 -65.491)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M326.93,95.777c.276.862-.355,1.477-1.408,1.374a2.949,2.949,0,0,1-2.407-1.747c-.276-.862.355-1.477,1.408-1.374A2.949,2.949,0,0,1,326.93,95.777Z",
    transform: "translate(-153.839 -61.034)",
    opacity: 0.2,
    fill: "url(#radial-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M256.23,77.159a1.489,1.489,0,1,1-1.487-1.571,1.491,1.491,0,0,1,1.384,1",
    transform: "translate(-74.677 -17.871)",
    opacity: 0.441,
    fill: "url(#radial-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M325.966,102.744c.276.862-.355,1.477-1.408,1.374a2.949,2.949,0,0,1-2.407-1.747c-.276-.862.355-1.477,1.408-1.374A2.949,2.949,0,0,1,325.966,102.744Z",
    transform: "translate(-153.058 -66.671)",
    opacity: 0.2,
    fill: "url(#radial-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M345.177,225.091c.477.647-.032,1.9-1.137,2.8s-2.388,1.1-2.865.455.032-1.9,1.137-2.8a2.861,2.861,0,0,1,2.412-.771",
    transform: "translate(-168.358 -166.77)",
    opacity: 0.54,
    fill: "url(#radial-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M232.547,47.8a26.081,26.081,0,0,0-36.942-.4l3.169,3.245a21.555,21.555,0,0,1,30.532.327",
    transform: "translate(-50.732 -17.28)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M351.966,120.744c.276.862-.355,1.477-1.408,1.374a2.949,2.949,0,0,1-2.407-1.747c-.276-.862.355-1.477,1.408-1.374A2.949,2.949,0,0,1,351.966,120.744Z",
    transform: "translate(-174.093 -81.233)",
    opacity: 0.2,
    fill: "url(#radial-gradient-39)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactOsProductLogo);
export default __webpack_public_path__ + "static/media/ReactOSProductLogo.3d14d29e7bbe6ddd3cd53f9b49ca2c07.svg";
export { ForwardRef as ReactComponent };